import React from "react";

export const CheckItem: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <li className="flex items-start gap-3 text-[var(--site-muted)]">
    <svg className="mt-0.5 h-5 w-5 shrink-0 text-[var(--site-cta)]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
    </svg>
    <span>{children}</span>
  </li>
);
